define('app/filters/SegmentFiltersView',['require','./SegmentCompoundFilterView','./FiltersView'],function(require) {
	'use strict';

	var SegmentCompoundFilterView = require('./SegmentCompoundFilterView'),
		FiltersView = require('./FiltersView');

	return FiltersView.extend({

		initialize: function(options) {

			FiltersView.prototype.initialize.apply(this, arguments, options);

			var report = this.model;

			this.topLevelFilterView = new SegmentCompoundFilterView({
				model: report.filter(),
				report: report
			});
		}
	});
});

